import baseTheme from '../baseTheme';
import colors from '../colors';
var MuiIconButton = {
    /* your custom class style overrides here */
    sizeSmall: {
        padding: '3px',
        fontSize: baseTheme.typography.pxToRem(baseTheme.typography.fontSize),
    },
    root: {
        padding: baseTheme.spacing(1.5),
        fontSize: '1rem',
    },
    colorPrimary: {
        color: colors.blue[700],
    },
};
export default MuiIconButton;
//# sourceMappingURL=MuiIconButton.js.map